import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'

// Initialize Firebase
var prod_config = {
  apiKey: "AIzaSyDlhe5B--Lh1jUz14Z2rSM-Rssb0fgN4kg",
  authDomain: "kibigo-prod.firebaseapp.com",
  databaseURL: "https://kibigo-prod.firebaseio.com",
  projectId: "kibigo-prod",
  storageBucket: "kibigo-prod.appspot.com",
  messagingSenderId: "815000762546"
};

var dev_config = {
  apiKey: "AIzaSyD2BM5ilZY_NO2QptSh2pgiTnKx6r282fQ",
  authDomain: "spark-portal-dev.firebaseapp.com",
  databaseURL: "https://spark-portal-dev.firebaseio.com",
  projectId: "spark-portal-dev",
  storageBucket: "spark-portal-dev.appspot.com",
  messagingSenderId: "762581116928"
};

if (process.env.NODE_ENV === 'production'){
  firebase.initializeApp(prod_config);
} else {
  //firebase.initializeApp(dev_config);
  firebase.initializeApp(prod_config);
}

const firestore = firebase.firestore()
const settings = {
  timestampsInSnapshots: true
}
firestore.settings(settings)
const storage = firebase.storage().ref()
export { firebase, firestore as database, storage }


// WEBPACK FOOTER //
// ./src/firebase/index.js